import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountInClosureCollectionModel } from '../../Models/Domains/Account/AccountClosure/AccountInClosureCollectionModel';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountInClosureClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(accountnumber: string, accountname: string, start: number, count: number): Promise<AccountInClosureCollectionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/AccountInClosure/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { accountnumber: accountnumber, accountname: accountname, start: start, count: count }

    return AjaxWrapper.get<AccountInClosureCollectionModel, any>(url, data);
  }
}

